import React, {useState} from 'react';
import TextField from './components/TextField';
import {FaMobileAlt} from 'react-icons/fa';
import Post from './components/Post';
import betx from './images/betx.png';
import splash3 from './images/splash3.jpg';
import color from './components/color';

const styles = {
  bg: {
    minHeight: '100vh',
    width: '100vw',
    backgroundImage: "url('/images/splash3.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  layer: {
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    width: '78%',
    marginTop: 20,
    borderRadius: 20,
    padding: 20,
    backgroundColor: 'rgba(0,0,0,0.4)',
    border: '1px solid #10C2AA',
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  loginBtn: {
    width: '100%',
    borderRadius: 10,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 30,
    padding: 15,
    backgroundColor: '#0AB4A7',
    border: 'none',
    color: 'white',
    fontWeight: 'bold',
    fontSize: 16,
    cursor: 'pointer',
  },
  inputWrapper: {
    display: 'block',
    alignItems: 'center',
    border: '2px solid #10C2AA',
    borderRadius: 10,
    backgroundColor: 'rgba(255,255,255,0.1)',
    padding: '10px 12px',
    marginBottom: 10,
    width: '90%',
  },
  placeholder: {
    color: '#fff',
  },
};

const Forgot = () => {
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);

  const forgot = async () => {
    if (!mobile) {
      window.alert('Please Enter Mobile Number');
      return;
    }
    setLoading(true);
    try {
      const res = await Post.Forgot({mobile});
      setLoading(false);
      if (res.id) {
        window.location.href = `/otp?id=${res.id}&type=forgot`;
      } else {
        window.alert(res.errorMsg || 'Error sending OTP');
      }
    } catch (e) {
      setLoading(false);
      window.alert('Error sending OTP');
    }
  };

  return (
    <>
      <style>{`
        .custominput::placeholder {
          color: white;
        }
      `}</style>
      <div style={{backgroundColor: 'black', minHeight: '100vh'}}>
        <div style={{...styles.bg, backgroundImage: `url(${splash3})`}}>
          <div style={styles.layer}>
            <div
              style={{
                height: 200,
                width: 200,
                marginTop: 20,
                borderRadius: 20,
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <img
                src={betx}
                alt="logo"
                style={{height: 200, width: 250, objectFit: 'contain'}}
              />
            </div>
            <h2
              style={{
                color: 'white',
                fontWeight: 'bold',
                fontSize: 20,
                marginTop: 10,
              }}>
              OTP to
            </h2>
            <h2
              style={{
                color: 'white',
                fontWeight: 'bold',
                fontSize: 20,
                marginTop: 10,
              }}>
              Reset Password?
            </h2>
            <div style={styles.card}>
              <div style={styles.inputWrapper}>
                <FaMobileAlt
                  color="white"
                  size={20}
                  style={{marginRight: 10}}
                />
                <input
                  type="tel"
                  maxLength={10}
                  placeholder="Mobile Number"
                  className="custominput"
                  value={mobile}
                  onChange={e =>
                    setMobile(e.target.value.replace(/[^0-9]/g, ''))
                  }
                  style={{
                    flex: 1,
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: 'white',
                    outline: 'none',
                  }}
                />
              </div>
              <button
                style={styles.loginBtn}
                onClick={forgot}
                disabled={loading}>
                {loading ? 'Sending...' : 'Next'}
              </button>
            </div>
            {/* <div style={styles.card}>
            <TextField
              label="Mobile Number"
              maxLength={10}
              value={mobile}
              onChange={e => setMobile(e.target.value.replace(/[^0-9]/g, ''))}
              type="tel"
              icon={
                <FaMobileAlt
                  style={{marginLeft: 10}}
                  color="#ffffff"
                  size={25}
                />
              }
            />
            <button style={styles.loginBtn} onClick={forgot} disabled={loading}>
              {loading ? 'Sending...' : 'Next'}
            </button>
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Forgot;
